import { render, staticRenderFns } from "./WorkflowEmailTemplateDropDownList.vue?vue&type=template&id=2a4f0442"
import script from "./WorkflowEmailTemplateDropDownList.vue?vue&type=script&lang=js"
export * from "./WorkflowEmailTemplateDropDownList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports